import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { useAuth } from "@/context/AuthContext";
import { useAccountingAccess } from "@/hooks/useAccountingAccess";
import { Spinner } from "@/components/Spinner";

/** admin หรือหัวหน้าทีม (ของทีมตัวเอง · /api/accounting/me) — ใช้กับหน้าจัดการสถานะ (เจ้าของระบบ 2026-10-06) · server ตรวจซ้ำทุกคำขอ */
export function AdminOrLeadOnly({ children }: { children: ReactNode }) {
  const { role, user, isLoading } = useAuth();
  const { allowed, teamLead } = useAccountingAccess();
  const location = useLocation();

  if (isLoading) return <Spinner className="min-h-[40vh]" />;
  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  if (role === "admin") return <>{children}</>;
  if (allowed === null) return <Spinner className="min-h-[40vh]" />; // ยังเช็คสิทธิ์หัวหน้าทีมไม่เสร็จ
  return teamLead ? <>{children}</> : <Navigate to="/" replace />;
}
